var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sorter d-flex"},[_c('span',[_vm._v("Sort by:")]),_c('b-form-select',{model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}},_vm._l((_vm.types),function(type){return _c('option',{key:type.name,domProps:{"value":type}},[_vm._v(" "+_vm._s(type.name)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }